import { forwardRef } from 'react';

import type {
  svgMapping as iconMapping,
  SvgProps,
} from '@onyx/ui/components/colleague/svg';
import { RenderSvg } from '@onyx/ui/components/colleague/svg';

export type IconMapping = keyof typeof iconMapping;
export type IconProps = SvgProps & {
  width?: never;
  height?: never;
  size?: number;
  isDisabled?: boolean;
};

export const Icon = forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
  const { className, size = 40, style, ...rest } = props;

  const renderSvgProps = {
    ref,
    style,
    className: `icon ${className || ''}`,
    outerSvgSize: size,
    ...rest,
  };

  return <RenderSvg {...renderSvgProps} />;
});
